import { render, staticRenderFns } from "./home_m.vue?vue&type=template&id=cdaff6c8&scoped=true"
import script from "./home_m.vue?vue&type=script&lang=js"
export * from "./home_m.vue?vue&type=script&lang=js"
import style0 from "./home_m.vue?vue&type=style&index=0&id=cdaff6c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaff6c8",
  null
  
)

export default component.exports